<div id="deleteLaptopPopup" class="card delete_laptop popup-body" dir={{direction}}>
  <div id="deleteLaptopPopupBody" class="popup-body">
    <a (click)="close()" class="popup_close">
      <img alt="go to profile page" />
    </a>
    <div id="deleteLaptopPopupHeader" class="form_header">
      <span i18n="@@profile.heading.delete-profile-name">Delete {{profileName}}?</span>
    </div>
    <div id="deleteLaptopPopupDesc" [innerHTML]="deletedDesc">

    </div>
    <div id="deleteLaptopPopupFooter" class="card-footer">
      <button type="button" class="btn btn-outline-primary gtmProfileDeleteCancel cancel-btn" [innerHTML]="cancel"
        (click)="close()">
      </button>
      <button type="button" class="btn btn-primary gtmProfileDeleteDeleteProfile delete-btn" (click)="deleteCurrentProfile()"
        [innerHTML]="deleteProfile">
      </button>
    </div>
  </div>
</div>